import React from 'react';
import './UniversityPage.css';

const UniversityPage8 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Campania "Luigi Vanvitelli"</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>Established in 1991, the University of Campania "Luigi Vanvitelli" was created to ease the overcrowding at the University of Naples Federico II. Its main headquarters are in Caserta, but its 16 departments are spread across five areas: Naples, Caserta, Aversa, Capua, and Santa Maria Capua Vetere. In 2016, it adopted its current name to honor the renowned architect Luigi Vanvitelli, the mastermind behind the Royal Palace of Caserta.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of UniCampania</h2>
                    <p>In the QS World University Rankings, the university is positioned between #651-700 globally. Specifically, for the 2024 QS WUR Ranking by Subject, it also falls within the #651-700 bracket.</p><a href="https://www.topuniversities.com/universities/universit-degli-studi-della-campania-luigi-vanvitelli?utm_source=chatgpt.com">topuniversities.com</a>
                    <p>When it comes to its medical faculty, the university holds a commendable position. According to EduRank 2024, it has ranked #25 in Italy and #157 in Europe for Medicine.</p> <a href="https://edurank.org/medicine/campania/?utm_source=chatgpt.com">edurank.org</a>
                    <p>Additionally, the Times Higher Education World University Rankings 2025 places the university in the 801–1000th bracket globally, with its Clinical and Health disciplines ranked between 401–500th.</p><a href="https://www.timeshighereducation.com/world-university-rankings/university-campania-luigi-vanvitelli?utm_source=chatgpt.com">timeshighereducation.com</a>
                    <p>These rankings highlight the university's strong performance and reputation in the medical field on both national and international stages.</p>
                </section>

                <section className="seats-available">
                    <h2>Seats Available</h2>
                    <p>The University of Campania "Luigi Vanvitelli" offers a limited number of seats for its medical program each year. For the <strong>2024 academic year</strong>, there are <strong>60 seats available for EU students</strong> and <strong>50 seats for non-EU students</strong>. Due to the high competition, securing admission requires strong IMAT scores and thorough preparation. With its growing reputation in medical education, the university attracts students from all over the world, making each seat highly coveted.</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Non-EU Seats</th>
                                    <th>EU Seats</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>60</td>
                                    <td>50</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="imat-scores">
                    <h2>IMAT Scores in Past Years and Cut-offs</h2>
                    <p>Below are the IMAT scores and cut-offs for the past few years:</p>
                    <div className="table-container">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Minimum Score (Non-European)</th>
                                    <th>European Scores (First/Last Round)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2021</td>
                                    <td>33.1</td>
                                    <td>First: 43.8 / Last: 33.3</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>41.9</td>
                                    <td>First: 43.2 / Last: 34.2</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>47.3</td>
                                    <td>First: 37.0 / Last: 35.0</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>63.2</td>
                                    <td>First: 59.5 / Last: --</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>Prospective students must meet the following requirements:</p>
                    <ul>
                        <li>A high school diploma equivalent to the Italian secondary school qualification. Minimum score should be 70%.</li>
                        <li>A valid IMAT score above the cutoff for their category (EU/non-EU).</li>
                        <li>Proof of English proficiency (for non-native speakers).</li>
                        <li>Visa and residence permit for non-EU students.</li>
                    </ul>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Subjects Taught</h2>
                    <p>The Medicine course at the University of Campania "Luigi Vanvitelli" is a comprehensive <strong>6-year</strong> program designed to equip students with both theoretical knowledge and clinical skills. The first two years focus on foundational sciences like biology, chemistry, and human anatomy, while the final four years emphasize clinical training, including internal medicine, surgery, pediatrics, and specialties. The program requires the completion of <strong>360 ECTS credits</strong>, with a significant portion dedicated to hands-on clinical experience.</p>

                    <h3>First Year</h3>
                    <ul>
                        <li>Biology, Molecular Biology and General Genetics</li>
                        <li>Chemistry</li>
                        <li>Physics Applied to Medical Sciences</li>
                        <li>Human Anatomy 1</li>
                        <li>Medical Histology and Embryology</li>
                        <li>Scientific English</li>
                        <li>Methodological Bases in Medicine and Bioethics</li>
                    </ul>

                    <h3>Second Year</h3>
                    <ul>
                        <li>Human Anatomy 2</li>
                        <li>Biochemistry</li>
                        <li>Medical Physiology</li>
                        <li>General Pathology, Pathophysiology and Medical Genetics 1</li>
                        <li>Immunology and Immunopathology</li>
                        <li>Microbiology</li>
                    </ul>

                    <h3>Third Year</h3>
                    <ul>
                        <li>General Pathology, Physiopathology and Medical Genetics 2</li>
                        <li>Methods in Epidemiology</li>
                        <li>Methods in Medicine and Surgery</li>
                        <li>Dermatology, Plastic and Reconstructive Surgery</li>
                        <li>Haematology and Oncology</li>
                        <li>Scientific English</li>
                        <li>Laboratory Medicine</li>
                    </ul>

                    <h3>Fourth Year</h3>
                    <ul>
                        <li>Cardiovascular Diseases</li>
                        <li>Endocrinology and Metabolic Diseases</li>
                        <li>Gut Diseases</li>
                        <li>Pathological Anatomy</li>
                        <li>Respiratory Diseases</li>
                        <li>Nephrology and Urology</li>
                        <li>Allergology, Clinical Immunology and Rheumatological Diseases</li>
                        <li>Orthopaedic Diseases and Rehabilitative Pathological Anatomy</li>
                    </ul>

                    <h3>Fifth Year</h3>
                    <ul>
                        <li>Hygiene and Preventive Infectious Diseases</li>
                        <li>Sensory Organ Disorders</li>
                        <li>Pharmacology</li>
                        <li>Radiology, Radiotherapy</li>
                        <li>Neurological Diseases</li>
                        <li>Psychiatry and Child Neuropsychiatry</li>
                    </ul>

                    <h3>Sixth Year</h3>
                    <ul>
                        <li>Gynaecology and Obstetrics</li>
                        <li>Legal and Occupational Medicine</li>
                        <li>Pediatrics</li>
                        <li>Medical and Surgical Emergencies</li>
                        <li>Internal Medicine and Geriatrics</li>
                        <li>General Surgery</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams</h2>
                    <p><strong>Assessment Methods:</strong></p>
                    <ul>
                        <li><strong>Written Exams:</strong> These tests evaluate students' theoretical knowledge across various medical disciplines.</li>
                        <li><strong>Oral Exams:</strong> Some courses may include oral examinations to assess understanding and communication skills.</li>
                        <li><strong>Practical Exams:</strong> Clinical skills are evaluated through practical assessments, ensuring students can apply their knowledge in real-world scenarios.</li>
                        <li><strong>Clinical Internships:</strong> Hands-on experience in hospitals and clinics is integral, with evaluations based on performance during these internships.</li>
                    </ul>
                    <p><strong>Grading System:</strong></p>
                    <p>To pass an exam, a minimum score of 18 out of 30 is required. Achieving a score of 30 may be awarded with honors, subject to unanimous approval by the examining board. If a student does not pass, no grade is assigned.</p>
                </section>

                <section className="tuition-fees">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p><strong>Tuition Fees:</strong></p>
                    <ul>
                        <li><strong>EU students:</strong> €200/year (university fees) + €140/year regional tax (compulsory) + €16.00 legal stamp (compulsory).</li>
                        <li><strong>Non-EU students:</strong> €140/year regional tax (compulsory) + €16.00 legal stamp (compulsory).</li>
                    </ul>
                    <p><strong>Scholarships:</strong> Managed by <strong>ADISURC</strong>. <a href="https://www.adisurcampania.it/">ADISURC Scholarships</a></p>
                </section>

                <section className="city-info">
                    <h2>Campania as a City and International Life in Campania</h2>
                    <p><strong>Campania</strong> is a region in southern Italy, and its capital is <strong>Naples</strong> (Napoli), which is full of life, culture, and some of the best food you'll ever taste. Perfect for students who want a bit of everything. Here's why:</p>
                    <ul>
                        <li><strong>Vibrant Culture and History:</strong> Naples is home to historic sites like Pompeii, the Amalfi Coast, and Mount Vesuvius. If you love history, art, and culture, you're going to be in heaven. Plus, the city itself is a maze of historic buildings and streets full of character.</li>
                        <li><strong>Student Life:</strong> Naples is buzzing with students from all over the world. Universities like the University of Campania "Luigi Vanvitelli" create a lively, energetic atmosphere. There are plenty of student clubs, activities, and events to keep you entertained.</li>
                        <li><strong>Cost of Living:</strong> Compared to other major Italian cities like Milan or Rome, Naples can be more affordable, especially for students. Housing and dining out can be budget-friendly, so you get the Italian experience without draining your wallet.</li>
                        <li><strong>Food:</strong> Naples is the birthplace of pizza, beyond pizza; the region has amazing local dishes, fresh seafood, and incredible pastries.</li>
                        <li><strong>Social Life and Nightlife:</strong> Naples has a mix of chill cafes, lively bars, and clubs. It has a perfect vibe for socializing, whether you are hanging out with friends or making new ones.</li>
                    </ul>
                </section>

                <section className="living-expenses">
                    <h2>Living Expenses</h2>
                    <ul>
                        <li><strong>Cost of living:</strong> Shared apartments range from €250-400 per month depending on location and amenities.</li>
                        <li><strong>Food and dining:</strong> Weekly grocery expenses average €30-60.</li>
                        <li><strong>Transportation:</strong> €35-€50.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>In conclusion, Campania, and especially Naples, is a fantastic destination for students who crave a vibrant and dynamic environment to balance their studies and enjoy life. With its rich culture, affordable cost of living, unforgettable food, and a mix of social activities, you will never be bored. The region's location offers amazing travel opportunities too. If you are looking for the full Italian experience with all the benefits, Campania is the place to be.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage8;